<template>
      <v-sheet class="home">
      <pull-to :top-config="TOP_DEFAULT_CONFIG" class="position-relative z2" :top-load-method="refresh">
        <v-sheet class="py-5">
          
          <v-container>
            <v-skeleton-loader
              v-if="loader"
              type="article"
            ></v-skeleton-loader>
            <div v-else>
              <p class="mt-4 mb-0"><small>Welcome Back</small></p>
              <h1 class="font-weight-black primary-color mb-0" style="line-height : normal">{{user.name}}</h1>
              <p class="font-weight-bold m-0">{{user.role.name}}</p>
              <router-link to="/profile" class="text-decoration-none primary-color"><small>Edit Profile</small></router-link>
            </div>

            
            <div class="text-center mt-5 mb-n5 fade-in">
              <h6>Pull to refresh</h6>
              <v-icon>mdi-chevron-down</v-icon>
            </div>
          </v-container>
        </v-sheet>
      </pull-to>

        <!-- <v-sheet class="py-5 primary-background" elevation="20" dark>
          <filter-widget />
        </v-sheet> -->
        <v-sheet class="pb-5">
          <v-btn to="/forms" block x-large flat depressed class="primary-background white--text" style="border-radius : unset">
            <div class="d-flex align-items-center justify-space-between" style="width : 100%"><span class="">Buat Voucher
              <v-icon style="margin-top : -3px">mdi-plus</v-icon></span>
            </div>
          </v-btn>
          <v-container>
            <card-lists :homepage="true" :receipts="receipts"/>
          </v-container>
        </v-sheet>
      </v-sheet>
</template>

<script>
import PullTo from 'vue-pull-to'
import FilterWidget from './component/FilterWidget.vue'
import {mapGetters , mapActions} from 'vuex'
import CardLists from './component/CardLists.vue'
export default {
  name: 'Home',
  components: {
    FilterWidget,
    CardLists,
    PullTo
  },
  data () {
    return {
      TOP_DEFAULT_CONFIG : {
        pullText: 'Pull to Refresh', // The text is displayed when you pull down
        triggerText: 'Fetching', // The text that appears when the trigger distance is pulled down
        loadingText: 'Loading...', // The text in the load
        doneText: 'Done', // Load the finished text
        failText: 'Failed', // Load failed text
        loadedStayTime: 400, // Time to stay after loading ms
        stayDistance: 70, // Trigger the distance after the refresh
        triggerDistance:30 // Pull down the trigger to trigger the distance
      }
    }
  },
  computed : {
    ...mapGetters({
      'user' : 'Auth/user',
      'receipts' : 'Forms/receipts',
      'loader' : 'Global/loader'
    })
  },
  mounted () {
    console.log(this.user)
    if (!localStorage.getItem("user")) {
      this.$router.push({
        name: "Login",
      })
    }
    this.getUser(this.user.email)
    this.getReceipts({id : this.user.id})
  },
  methods : {
    ...mapActions({
      getUser : 'Auth/getUser',
      getReceipts : 'Forms/getReceipts'
    }),
    async refresh(loaded) {
      await this.getUser(this.user.email)
      await this.getReceipts({id : this.user.id})
      loaded('done')
    },
  }
}
</script>

<style scoped>
.home {
  background : #fff;
  min-height: calc(100vh - 80px);
}
.z2 {
  z-index: 2;
}
</style>
